import * as React from "react";
import "../../resources/styles/components/notification-modal.scss";
import { Modal } from "react-bootstrap";


type Props = {
    modalText: string,
    modalBodyText: string,
    modalCloseButtonText: String,
    successNotification?: boolean,
    modalButtonHandler: () => void,
    exitModalHandler: () => void,
}

type State = {}

/**
 * Error modal to give the user messages depending on the passed in props.
 * Currently displays in the following events:
 * * Code timeout -> request new code
 * * Too many attempts to enter code -> request new code
 * * Invalid code -> no new code requested
 */
export default class NotificationModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    render () {
        return (
            <>
                <Modal.Body>
                    <button type="button" className="close" onClick={() => this.props.exitModalHandler()}>
                        <span aria-hidden="true">×</span><span className="sr-only">Close</span>
                    </button>
                    <div>
                        <span className={"mb-20 d-block mx-auto mp-notification-icon " + (this.props.successNotification ? "verified-check-icon-small" : "alert-triangle-icon")} />
                        <h1 className={"mb-10 modal-text-centered modal-text-header-" + (this.props.successNotification ? "success" : "error")}>{this.props.modalText}</h1>
                        <p className="mb-30 modal-text-centered modal-text-body">{this.props.modalBodyText}</p>
                    </div>
                    <div className="text-centered">
                        <button className="mp-btn mp-btn-secondary mp-btn-medium" onClick={() => this.props.modalButtonHandler()}>{this.props.modalCloseButtonText}</button>
                    </div>
                </Modal.Body>
            </>
        );
    }
}